<template>
    <div class="mt-2">
        <div v-if="students.length">
            <v-select
                v-model="term"
                label="Term"
                class="pl-1"
                :items="getTerms()"
                style="max-width: 250px;"
            ></v-select>
            <v-expansion-panel class="expansion-panel-margin">
                <v-expansion-panel-content
                    v-for="(student, index) in getStudents()"
                >
                    <template v-slot:header>
                        <v-flex xs3>
                            <v-layout column class="py-0 ma-0">
                                <v-layout row class="pa-0 ma-0">
                                    <div class="subheading mb-1">
                                        {{ student.hebName }}
                                    </div>
                                    <div
                                        class="subheading ml-2 mb-1 text-info"
                                        v-if="student.nonUTA"
                                    >
                                        Non UTA
                                    </div>
                                </v-layout>
                                <div class="text--disabled subheading">
                                    {{ student.engName }}
                                </div>
                            </v-layout>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <div
                            v-if="student.skipcard"
                            class="text-danger subheading text-xs-center"
                        >
                            {{ student.skipcard }}
                        </div>
                        <div
                            v-if="student.studentRegistered"
                            class="subheading text-xs-center mx-2"
                            v-bind:class="{
                                'text-success': student.studentRegistered,
                                'text-danger': !student.studentRegistered,
                            }"
                        >
                            {{
                                student.studentRegistered
                                    ? "REGISTERED"
                                    : "NOT REGISTERED"
                            }}
                        </div>
                        <v-spacer></v-spacer>

                        <v-flex xs6>
                            <v-layout
                                column
                                align-end
                                justify-end
                                class="ml-0 mr-2"
                            >
                                <v-layout
                                    row
                                    class="subheading mb-1 text-xs-right mr-0"
                                >
                                    <div v-if="student.building">
                                        <span class="font-weight-medium"
                                            >Building:</span
                                        >
                                        {{ " " + student.building + " | " }}
                                    </div>
                                    <span class="font-weight-medium"
                                        >Branch:</span
                                    >
                                    {{ " " + student.branch + " | " }}
                                    <span class="font-weight-medium"
                                        >Grade:</span
                                    >
                                    {{ " " + student.class + " | " }}
                                    <div v-if="student.section">
                                        <span class="font-weight-medium"
                                            >Section:</span
                                        >
                                        {{ " " + student.section }}
                                    </div>
                                </v-layout>
                                <div class="text--disabled subheading">
                                    <span v-if="student.voucherStatus"
                                        >Voucher Status:

                                        <span
                                            :style="{
                                                color: getVoucherStatusTextColor(
                                                    student.voucherStatus,
                                                ),
                                            }"
                                        >
                                            {{ student.voucherStatus }}
                                        </span>
                                        {{ " | " }}</span
                                    >
                                    Immunizations Status:
                                    {{
                                        student.missingImm
                                            ? "Missing: " + student.missingImm
                                            : "OK"
                                    }}
                                </div>
                            </v-layout>
                        </v-flex>
                    </template>
                    <v-card>
                        <div class="mx-3 pl-1 mb-1">
                            <div class="mt-3">
                                <!-- <div class="mt-0 px-2 py-1 font-weight-medium title"
                            style="background-color: #5cb860; color: #fff; width: fit-content;"
                        >
                                {{ student.engName }} -
                                {{ student.hebName }}
                            </div> -->
                                <!-- <v-layout
                            style="color: #5cb860;"
                            row
                            justify-space-between
                            class="mt-0 mx-0 font-weight-medium title"
                        >
                            <div>
                                {{ student.engName }} -
                                {{ student.hebName }}
                            </div>
                            <div class="mr-2">{{ student.class }}</div>
                        </v-layout>
                        <div class="mt-2">
                            <div class="font-weight-medium subheading">
                                Immunizations Status:
                            </div>
                            <div class="">
                                {{
                                    student.missingImm
                                        ? student.missingImm
                                        : "OK"
                                }}
                            </div>
                        </div> -->
                                <v-layout
                                    row
                                    class="px-3 mb-2"
                                    v-for="prop in getStudentProperties(
                                        student,
                                    )"
                                >
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        {{ prop.name }}:
                                    </div>
                                    <div>
                                        {{ prop.value }}
                                    </div>
                                </v-layout>
                                <div class="mt-3 pl-1 mb-2" v-if="student.did">
                                    <div class="font-weight-medium subheading">
                                        Conferecne Line:
                                    </div>
                                    <div class="">
                                        {{
                                            (student.did
                                                ? formatPhoneNumber(
                                                      student.did,
                                                  ) + " - "
                                                : "") +
                                                (student.pin ? student.pin : "")
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- <v-divider
                    class="mb-3 mt-3 pb-2"
                    v-if="index + 1 < students.length"
                ></v-divider> -->
        </div>
        <div v-if="!getStudents().length" class="mt-2 text-xs-center">
            No Students
        </div>
    </div>
</template>
<script>
import { formatPhoneNumber, except, toTitleCase } from "../../utils/helpers.js";
import moment from "moment";
import { loadOptions } from "../../utils/smLookup.js";

export default {
    props: {
        students: Array,
    },
    data() {
        return {
            term: "",

            voucherStatuses: [],
        };
    },
    watch: {
        students(newValue) {
            if (newValue) {
                this.term = this.getTerms()[0];
            }
        },
    },
    async created() {
        this.term = this.getTerms()[0];

        await this.loadVoucherStatuses();
    },
    computed: {},
    methods: {
        getTerms() {
            return this.students
                .map((s) => s.regID)
                .filter(Boolean)
                .sort()
                .reverse();
        },
        getStudents() {
            return this.students.filter((s) => s.regID == this.term);
        },
        formatPhoneNumber(phone) {
            return formatPhoneNumber(phone);
        },
        getStudentProperties(student) {
            return Object.keys(
                except(
                    student,
                    "did",
                    "pin",
                    "hebName",
                    "engName",
                    "enrollment",
                ),
            )
                .map((key) => {
                    const value =
                        key == "dob"
                            ? moment(student[key]).format("MM/DD/YYYY")
                            : student[key];
                    return {
                        name: toTitleCase(key),
                        value: value,
                    };
                })
                .filter((v) => v.value);
        },
        async loadVoucherStatuses() {
            const statuses = await this.$http.get(
                "api/VoucherStudentStatus/GetVoucherStatuses",
            );

            this.voucherStatuses = statuses.sort(
                (a, b) => a.sortOrder - b.sortOrder,
            );
        },
        getVoucherStatusTextColor(status) {
            if (!status) return;

            const vhStatus = this.voucherStatuses.find(
                (s) => s.status == status,
            );

            return vhStatus && vhStatus.color ? vhStatus.color : "";
        },
    },
};
</script>
<style>
.card-width {
    max-width: 65%;
}
</style>
